import { Box, Divider, Menu, MenuItem, Typography } from "@mui/material";
import { ResponsiveDropdownItem, itemLinkProps } from "./common";

interface Props {
  id?: string;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  items: ResponsiveDropdownItem[];
  onItemClick: (item: ResponsiveDropdownItem) => void;
}

export const ResponsiveDropdownMenu = ({
  id,
  anchorEl,
  onClose,
  items,
  onItemClick,
}: Props) => (
  <Menu
    id={id}
    open={Boolean(anchorEl)}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    transformOrigin={{ vertical: "top", horizontal: "right" }}
    slotProps={{ paper: { sx: { mt: 1 } } }}
  >
    {items.flatMap((item) => {
      const menuItem = (
        <MenuItem
          key={item.label}
          data-testid={item.testId}
          selected={item.selected}
          onClick={() => onItemClick(item)}
          {...itemLinkProps(item)}
        >
          <Box display="flex" alignItems="center" gap={3} color={item.color}>
            {item.icon}
            <Typography variant="body3" color="inherit">
              {item.label}
            </Typography>
          </Box>
        </MenuItem>
      );

      return item.startsGroup
        ? [<Divider key={`${item.label}-divider`} />, menuItem]
        : [menuItem];
    })}
  </Menu>
);
